import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import SweetAlert from "react-bootstrap-sweetalert";
import classNames from "classnames";
import ReactLoading from "react-loading";

import { makeStyles } from "@material-ui/core/styles";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";

import Button from "components/CustomButtons/Button.js";
import paymentShop from "api/paymentShop.js";

import shippingAddressStyle from "assets/jss/material-dashboard-pro-react/views/shippingAddressStyle.js";
import menuStyle from "assets/jss/material-dashboard-pro-react/views/menuStyle.js";

import config from "config/config.js";

const useStyles = makeStyles(shippingAddressStyle);
const useStylesAlert = makeStyles(menuStyle);

export default function CashPayButton(props) {
  const {
    currency,
    active,
    cart,
    shippingInfo,
    paymentResponse,
    totalPrice,
    updateReservations,
    freeTickets,
    customStyle,
    showPopup,
    museum,
    cartUnique,
    enableLoading,
  } = props;

  const { t } = useTranslation();
  const classes = useStyles();
  const classesAlert = useStylesAlert();

  const [showAlert, setShowAlert] = useState(false);
  const [select, setSelect] = useState(0);
  const [loading, setLoading] = useState(false);
  const list = [
    {
      title: t("payment.cash_pay_right"),
      _id: "RIGHT",
    },
    {
      title: t("payment.cash_pay_20"),
      _id: "20",
    },
    {
      title: t("payment.cash_pay_30"),
      _id: "30",
    },
    {
      title: t("payment.cash_pay_50"),
      _id: "50",
    },
    {
      title: t("payment.cash_pay_100"),
      _id: "100",
    },
  ];

  function onSuccess() {
    setShowAlert(false);
    function compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const idA = a.index;
      const idB = b.index;

      let comparison = 0;
      if (idA > idB) {
        comparison = 1;
      } else if (idA < idB) {
        comparison = -1;
      }
      return comparison;
    }

    cart.sort(compare);

    const items = [];
    cartUnique.forEach((item) => {
      item.data.forEach((element) => {
        items.push({
          visitatore: element.visitatore,
          quantity: 1,
          articolo: element.productId,
          operatore: "Sito",
          prezzo: element.price,
          eventInfo: element.item,
          dataSelected: element.dateTimeSelected,
        });
      });
    });

    const museumInfo = {
      orgId: museum.organisation.id,
      museo: museum.organisation.id,
      mobile: false,
      metodo_pagamento: "Contanti",
      date: shippingInfo.date,
      payer: {
        firstName: shippingInfo.firstName,
        lastName: shippingInfo.lastName,
        card: shippingInfo.card,
        prefix: shippingInfo.prefix,
        telephone: shippingInfo.telephone,
        email: shippingInfo.email,
      },
      totalPrice,
    };

    let eventInfo = null;
    if (
      cart.item &&
      cart.item.nome &&
      cart.item.id &&
      cart.item.schema_eventi &&
      cart.item.schema_eventi.nome_evento
    ) {
      eventInfo = {
        id_articolo: cart.item.id,
        nome_articolo: cart.item.nome,
        nome_categoria: cart.item.schema_eventi.nome_evento,
      };
    }
    const objectToSend = {
      items,
      metodo_pagamento: "Contanti",
      ...museumInfo,
    };
    if (eventInfo) {
      Object.assign(objectToSend, { eventInfo });
    }
    if (freeTickets) {
      objectToSend.metodo_pagamento = "Online";
    }

    enableLoading(true);
    return paymentShop(objectToSend).then((response) => {
      setLoading(false);
      if (response) {
        updateReservations(response);
        return paymentResponse(
          { message: "OK", reservations: response },
          "SUCCESS_CASH"
        );
      } else {
        return paymentResponse({ message: "ERROR" }, "ERROR");
      }
    });
  }

  const confirmClass = classNames({
    [classesAlert.buttonAlert]: true,
    [classesAlert.totalButton]: true,
  });

  return (
    <>
      <div>
        {loading ? (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ReactLoading
              type={"spinningBubbles"}
              color={"#303030"}
              height={50}
              width={50}
            />
          </div>
        ) : (
          <Button
            round
            size="sm"
            style={{ width: "100%", backgroundColor: customStyle.buttonAction }}
            // color="github"
            className={classes.buttonBig}
            color="lightBlue"
            // onClick={onSuccess}
            onClick={() => {
              setLoading(true);
              if (showPopup) {
                setShowAlert(true);
                setLoading(false);
              } else {
                onSuccess();
              }
            }}
            disabled={!active}
          >
            {!freeTickets && (
              <img
                className="paypal-button-logo paypal-button-logo-pp paypal-button-logo-blue"
                src={`${config.cdn}icona-pagamento-in-consegna.png`}
                alt="cash"
                style={{ height: "20px", width: "50px", color: "white" }}
              />
            )}
            <span className={classes.buttonTextNormal}>
              {freeTickets
                ? t("shippingAddress.free")
                : t("shippingAddress.cash_pay")}
            </span>
          </Button>
        )}
      </div>
      {showAlert ? (
        <SweetAlert
          error={false}
          style={{
            display: "block",
            top: "20%",
            marginTop: "0px",
            paddingBottom: 0,
            maxHeight: "calc(100vh - 150px)",
            overflowY: "auto",
          }}
          onConfirm={onSuccess}
          onCancel={() => {
            setShowAlert(false);
          }}
          title={t("payment.how_pay")}
          showCancel={false}
          showConfirm={false}
        >
          <div>
            <Button
              round
              size="sm"
              color="transparent"
              className={classes.buttonSmall}
              style={{
                border: 0,
                position: "absolute",
                right: "7px",
                top: "5px",
                height: "46px",
                width: "46px",
                borderRadius: "32px",
              }}
              onClick={() => {
                setShowAlert(false);
              }}
            >
              <span className={classes.buttonText} style={{ fontSize: "11px" }}>
                <CloseIcon
                  style={{ marginRight: 0, color: customStyle.buttonAction }}
                />
              </span>
            </Button>
            {list.map((el, index) => {
              return (
                <div
                  onClick={() => {}}
                  key={el._id}
                  style={{
                    position: "relative",
                    borderBottom:
                      index + 1 === list.length ? "none" : "solid 1px #cbcbcb",
                  }}
                >
                  <div
                    className={classes.titleAdd}
                    style={{
                      lineHeight: "40px",
                    }}
                  >
                    {el.title} {el._id === "RIGHT" ? "" : currency}
                  </div>
                  <Button
                    round
                    size="sm"
                    color="transparent"
                    className={classes.buttonSmall}
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      // backgroundColor: customStyle.buttonContinue
                      borderColor: customStyle.buttonAction,
                    }}
                    onClick={() => {
                      setSelect(index);
                    }}
                  >
                    <span
                      className={classes.buttonText}
                      style={{
                        fontSize: "11px",
                        paddingLeft: "2px",
                      }}
                    >
                      {select === index ? (
                        <CheckIcon
                          style={{ color: customStyle.buttonAction }}
                        />
                      ) : (
                        ""
                      )}
                    </span>
                  </Button>
                </div>
              );
            })}
            <div style={{ textAlign: "center", marginBottom: "10px" }}>
              <Button
                round
                size="sm"
                onClick={() => {
                  setShowAlert(false);
                }}
                disabled={loading}
                className={`${classesAlert.buttonAlert}`}
                style={{
                  marginRight: "10px",
                  marginLeft: "10px",
                  backgroundColor: `${customStyle.buttonBackToMenu}`,
                }}
              >
                <span className={classes.buttonTextNormal}>
                  {t("menuList.cancel_button").toUpperCase()}
                </span>
              </Button>
              <Button
                round
                size="sm"
                color="warning"
                onClick={onSuccess}
                className={`${confirmClass}`}
                style={{
                  backgroundColor: `${customStyle.buttonCart}`,
                }}
              >
                <span className={classes.buttonTextNormal}>
                  {`${t("shippingAddress.cash_pay").toUpperCase()}`}
                </span>
              </Button>
            </div>
          </div>
        </SweetAlert>
      ) : null}
    </>
  );
}

CashPayButton.propTypes = {
  totalPrice: PropTypes.number.isRequired,
  deliveryPrice: PropTypes.number.isRequired,
  servicePrice: PropTypes.number.isRequired,
  subPrice: PropTypes.number.isRequired,

  language: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  commit: PropTypes.bool,
  cart: PropTypes.array.isRequired,
  coupon: PropTypes.object,
  discount: PropTypes.number,
  vat: PropTypes.number,
  shippingInfo: PropTypes.shape({
    // SHIPPING INFO
    city: PropTypes.string,
    subLocality: PropTypes.string,
    cap: PropTypes.string,
    address: PropTypes.string,
    indoor: PropTypes.string,
    floor: PropTypes.any,
    // telephoneDelivery: PropTypes.string,
    date: PropTypes.any,
    time: PropTypes.string,
    // CONTACTS
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    prefix: PropTypes.string,
    telephone: PropTypes.string,
  }).isRequired,
  museum: PropTypes.objectOf(PropTypes.any).isRequired,
  active: PropTypes.bool.isRequired,
  advisorId: PropTypes.string,
  paymentResponse: PropTypes.func,
  updateReservations: PropTypes.func.isRequired,
  feeCosts: PropTypes.number,
  deliveryCosts: PropTypes.number,

  customStyle: PropTypes.object,
  showPopup: PropTypes.bool,
  freeTickets: PropTypes.bool,
  //
  cartUnique: PropTypes.arrayOf(PropTypes.any).isRequired,
};

CashPayButton.defaultProps = {
  language: "it",
  customDiscount: {},
  commit: false,
  freeTickets: false,
  prevExpiringDate: null,
  coupon: {},
  vat: 0,
  discount: 0,
  advisorId: "",
  paymentResponse: () => {},
  feeCosts: 0,
  deliveryCosts: 0,
  customStyle: {},
};
